import { useEffect, useState } from "react";
import { format } from "date-fns";
import { Loader2 } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { getAvailability } from "@/lib/api";

const toMonth = (d) => format(d, "yyyy-MM");
const fmt12 = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};
export { fmt12 };

export const AppointmentPicker = ({ serviceId, date, time, onChange }) => {
  const [month, setMonth] = useState(date ? new Date(`${date}T12:00:00`) : new Date());
  const [avail, setAvail] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!serviceId) return;
    setLoading(true);
    getAvailability(serviceId, toMonth(month))
      .then((r) => setAvail(r.dates))
      .catch(() => setAvail({}))
      .finally(() => setLoading(false));
  }, [serviceId, month]);

  const selected = date ? new Date(`${date}T12:00:00`) : undefined;
  const slots = date ? avail[date] || [] : [];

  return (
    <div className="grid gap-8 md:grid-cols-[auto_1fr]">
      <div data-testid="book-calendar" className="rounded-xl border border-slate-200 bg-white">
        <Calendar
          mode="single"
          month={month}
          onMonthChange={setMonth}
          selected={selected}
          onSelect={(d) => d && onChange({ date: format(d, "yyyy-MM-dd"), time: "" })}
          disabled={(d) => !avail[format(d, "yyyy-MM-dd")]}
          fromDate={new Date()}
        />
      </div>
      <div>
        <p className="text-sm font-medium text-slate-600">
          {date ? `Available times on ${format(selected, "EEEE, MMM d")}` : "Select a highlighted date to see available times."}
          {loading && <Loader2 className="ml-2 inline h-4 w-4 animate-spin text-gold" />}
        </p>
        <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-4">
          {slots.map((t) => (
            <button key={t} type="button" data-testid={`book-slot-${t.replace(":", "")}`} onClick={() => onChange({ date, time: t })}
              className={`rounded-lg border px-2 py-2.5 text-sm font-medium transition-colors ${time === t ? "border-gold bg-gold text-[#0B132B]" : "border-slate-300 text-slate-700 hover:border-gold"}`}>
              {fmt12(t)}
            </button>
          ))}
        </div>
        {date && !slots.length && !loading && <p className="mt-4 text-sm text-slate-500">No times left on this date. Please choose another day.</p>}
        <p className="mt-6 text-xs text-slate-400">Times shown in Eastern Time. Your request stays pending until our team confirms it.</p>
      </div>
    </div>
  );
};
